import PropTypes from 'prop-types'
import React from 'react'
import {noop} from '@republic/foundation/lang/function'
import {createComponent} from '@republic/react-foundation'
import ModalContainer from '../ModalContainer'
import Layout from '../Layout'

export default (
    createComponent(
        'Modal',
        {
            propTypes: {
                name: PropTypes.string.isRequired,
                background: PropTypes.bool,
                dismiss: PropTypes.func,
                force: PropTypes.bool,
                layer: PropTypes.number
            },
            defaultProps: {
                background: true,
                dismiss: noop,
                force: false,
                layer: 100
            }
        },
        ({name, background, dismiss, force, children, layer}) => (
            <ModalContainer name={name}>
                {({shown}) => (
                    (shown || force) ?
                        <Layout
                            row
                            position={'fixed'}
                            positions={0}
                            align={'center'}
                            justify={'center'}
                            layer={layer}>
                            {background &&
                                <Layout
                                    onClick={() => dismiss()}
                                    position={'fixed'}
                                    positions={0}
                                    color={'rgba(0,0,0,0.65)'} />}
                            <Layout layer={1}>{children}</Layout>
                        </Layout> :
                        null)}
            </ModalContainer>)))
